import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { ConfigurationEmailJobsService } from '../configuration-email-jobs.service';
import { ConfigurationEmailJobTriggersViewPart } from './email-job-triggers/email-job-triggers-view.part';
import { ConfigurationEmailJobsViewPart } from './email-jobs/email-jobs-view.part';

@Component({
	selector: 'configuration-email-jobs-views-part',
	standalone: true,
	imports: [
		ConfigurationEmailJobsViewPart,
		ConfigurationEmailJobTriggersViewPart,
		DroplistWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './email-jobs-views.part.html',
})
export class ConfigurationEmailJobsViewsPart implements OnInit {

	public service = inject(ConfigurationEmailJobsService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}